<template>
    <div class="backoffice-members-view">
        <div class="grid">
            <v-card class="menu">
                <div class="user-info">
                    <div class="image-wrap">
                        <v-progress-circular v-show="imageLoading" class="image-loader" indeterminate color="primary"></v-progress-circular>
                        <img :src="memberData.profile_photo_url + '?w=220'" alt="" v-show="!imageLoading">
                        <div class="upload">
                            <v-file-input
                            v-model="memberPhoto"
                            prepend-icon="mdi-camera-outline"
                            @change="onFileChange">
                            </v-file-input>
                        </div>
                    </div>
                    <div class="user">
                        <h3 class="name">{{ memberData.first_name + ' ' + memberData.last_name}}</h3>
                        <p class="email">{{ memberData.email }}</p>
                    </div>
                    <v-snackbars :objects.sync="messageObjects" top right>
                        <template v-slot:action="{ close }">
                            <v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
                        </template>
                    </v-snackbars>
                </div>
                <v-divider/>
                <v-list expand nav dense>
                    <inertia-link :href="'/portal/profile/'">
                        <v-list-item link :class="{'v-list-item--active' : $page.component==='Portal/Profile/Index'}">
                            <v-list-item-icon><v-icon>mdi-account-multiple-check-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.details || "Details" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link :href="'/portal/profile/password/'">
                        <v-list-item link :class="{'v-list-item--active' : $page.component==='Portal/Profile/Password'}">
                            <v-list-item-icon><v-icon>mdi-account-cash-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.password || "Password" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                </v-list>
            </v-card>
            <v-card class="panel" @edited="editedMember">
                <slot></slot>
            </v-card>
        </div>
    </div>
</template>

<script>

import EventBus from '@/js/eventbus';

export default {
	name: "PortalLayout",
	components: {
	
	},
    props: {
        lang: Object
    },
	data() {
		return {
            memberData: this.$page.props.member,
            imageLoading: false,
            memberPhoto: null,
            messageObjects: []
		}
	},
    methods: {
        onFileChange() {
            if(this.memberPhoto) {
                this.imageLoading = true
                let file =  this.memberPhoto
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData()
                formData.append('photo', file)
                formData.append('member_id', this.$page.props.member.id)
                axios.post('/portal/profile/upload_photo', formData, config)
                    .then(response => {

                        var messageType = "success";
                        this.imageLoading = false
                       
                        if (response.data.status != "OK") {
                            messageType = "error";
                        }else{
                           this.memberData.profile_photo_url = response.data.photo_path;
                        }
                        
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: messageType,
                            timeout: 5000
                        });

                    })
                    .catch(error => {
                        if(error) {

                            EventBus.$emit('SHOW_NOTIFICATION', {
                            message: error.response.data.message,
                            color: messageType,
                            timeout: 5000
                        });
                            
                        this.imageLoading = false
                        }
                    })
            }
        },
		editedMember(value) {
			this.memberData = Object.assign({}, value)
        }
	}
}
</script>
